<template>
  <div>
    <group-banner-create-edit-form />
  </div>
</template>

<script>
  import GroupBannerCreateEditForm from './components/GroupBannerCreateEditForm.vue';
  export default {
    components: { GroupBannerCreateEditForm },
  };
</script>

<style></style>
